<template>
	<div class="map_index">
		<!-- 地图容器 -->
		<div class="map" id="container"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				markerArr: [{
					id: "1", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
					styleId: "myStyle", //指定样式id
					position: new TMap.LatLng(28.075, 112.9892), //点标记坐标位置
					properties: {
						//自定义属性
						title: "湘楚人力"
					}
				}]
			};
		},
		mounted() {
			// 调用
			this.initMap();
		},
		methods: {
			initMap() {
        return
				//初始化地图
				var map = new TMap.Map(document.getElementById("container"), {
					center: new TMap.LatLng(28.0752, 112.9888), //设置地图中心点坐标
					zoom: 18,   //设置地图缩放级别
					// pitch: 43.5,  //设置俯仰角
					// rotation: 45    //设置地图旋转角度
				});
				//设定marker点及其样式
				var markerLayer = new TMap.MultiMarker({
					map: map, //指定地图容器
					styles: {
						// mark样式
						"marker": new TMap.MarkerStyle({
							"width": 25,
							"height": 38,
							"anchor": {
								x: 12,
								y: 32
							},
						})
					},
					//点标记数据数组
					geometries:  [{
						id: "markerOne", //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
						styleId: "marker", //指定样式id,要与上方styleid统一
						position: new TMap.LatLng(28.0752, 112.9888), //点标记坐标位置
						properties: {
							//自定义属性
							title: "湘楚人力"
						}
					}]
				});
				//设置信息窗口
				var infoWindow = new TMap.InfoWindow({
					map: map,
					content: '湖南省长沙市天心区芙蓉南路390号悦动商业广场C座926、927号',
					position: new TMap.LatLng(28.0752, 112.9888), //信息窗口默认位置
					offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
				});
			}
		}
	};
</script>
<style scoped lang="scss">
	.map_index {
		width: 100%;
		padding-bottom: 128px;

		.map {
			width: 65%;
			margin: 0 auto;
		}
	}
</style>
